
import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  WebsiteCreation,
  WebsiteCreationAction,
  WebsiteDeletion,
  WebsiteDeletionAction,
  WebsiteOrchestratorResourceType,
} from '@/services/Website/interfaces';

@Component
export default class DeletionOrchestratorStatus extends Vue {
  @Prop({ type: Number, required: true })
  public websiteId!: number;

  @Prop({ default: null })
  public creation!: WebsiteCreation | null;

  @Prop({ default: null })
  public deletion!: WebsiteDeletion | null;

  @Prop({ type: Boolean, default: false })
  public loading!: boolean;

  public get creationActions(): WebsiteCreationAction[] {
    if (!this.creation || !this.creation.actions) {
      return [];
    }
    return this.creation.actions;
  }

  public get deletionActions(): WebsiteDeletionAction[] {
    if (!this.deletion || !this.deletion.actions) {
      return [];
    }
    return this.deletion.actions;
  }

  public get creationRoute(): { name: string; params: { websiteId: string; resourceType: string; resourceId: string } } {
    return {
      name: 'view_resource',
      params: {
        websiteId: String(this.websiteId),
        resourceType: String(WebsiteOrchestratorResourceType.CREATION),
        resourceId: String(this.creation ? this.creation.id : 0),
      },
    };
  }

  public get deletionRoute(): { name: string; params: { websiteId: string; resourceType: string; resourceId: string } } {
    return {
      name: 'view_resource',
      params: {
        websiteId: String(this.websiteId),
        resourceType: String(WebsiteOrchestratorResourceType.DELETION),
        resourceId: String(this.deletion ? this.deletion.id : 0),
      },
    };
  }

  public actionLabel(action: string): string {
    const map: { [key: string]: string } = {
      create_dns: 'CREATE DNS',
      delete_dns: 'DELETE DNS',
      create_unix_user: 'CREATE UNIX USER',
      delete_unix_user: 'DELETE UNIX USER',
      create_database: 'CREATE DATABASE',
      delete_database: 'DELETE DATABASE',
      create_vhost: 'CREATE VHOST',
      delete_vhost: 'DELETE VHOST',
      create_redis_cache: 'CREATE REDIS CACHE',
      delete_redis_cache: 'DELETE REDIS CACHE',
      create_email: 'CREATE EMAIL',
      delete_email: 'DELETE EMAIL',
      create_letsencrypt: 'CREATE LETS ENCRYPT',
      delete_letsencrypt: 'DELETE LETS ENCRYPT',
      activate_cdn: 'ACTIVATE CDN',
      deactivate_cdn: 'DEACTIVATE CDN',
      install_wp: 'INSTALL WP',
      uninstall_wp: 'UNINSTALL WP',
      clone_wp: 'CLONE WP',
      delete_ftp: 'DELETE FTP',
    };
    return map[action] || (action || '').replace(/_/g, ' ').toUpperCase();
  }

  public statusIcon(status: string): string {
    const map: { [key: string]: string } = {
      pending: 'mdi-progress-clock',
      'in progress': 'mdi-progress-helper',
      failed: 'mdi-close-thick',
      retry: 'mdi-repeat',
      retrying: 'mdi-repeat-variant',
      done: 'mdi-check',
      'rolling back': 'mdi-arrow-u-left-top',
      'rolled back': 'mdi-backup-restore',
      cancelled: 'mdi-cancel',
    };
    return map[(status || '').toLowerCase()] || 'mdi-circle-outline';
  }

  public statusColor(status: string): string {
    const map: { [key: string]: string } = {
      pending: 'grey',
      'in progress': 'info',
      failed: 'error',
      retry: 'warning',
      retrying: 'warning',
      done: 'success',
      'rolling back': 'orange',
      'rolled back': 'orange',
      cancelled: 'grey',
    };
    return map[(status || '').toLowerCase()] || 'grey';
  }
}
